module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(['home', 'portfolio', 'calculator', 'hydrocalc', 'contact', '404'].indexOf(_vm.$route.name) !== -1) ? _c('div', {
    staticClass: "bg"
  }) : _vm._e(), _vm._v(" "), _c('section', {
    class: {
      'hero header': true, 'is-fullheight is-fh-adj': _vm.$route.name === 'home'
    }
  }, [_c('div', {
    staticClass: "hero-head head-has-affix"
  }, [_c('header', {
    staticClass: "nav head-affix"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    staticStyle: {
      "max-height": "2.5rem"
    },
    attrs: {
      "src": require("./assets/logos/logo-alt.svg")
    }
  })]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('span', {
    class: {
      'nav-toggle': true, 'is-active': _vm.navOpen
    },
    on: {
      "click": function($event) {
        _vm.navOpen = !_vm.navOpen
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    class: {
      'nav-right nav-menu': true, 'is-active': _vm.navOpen
    },
    on: {
      "click": function($event) {
        _vm.navOpen = false
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'home'
      },
      "exact": ""
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'services'
      }
    }
  }, [_vm._v("Services")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'portfolio'
      }
    }
  }, [_vm._v("Portfolio")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'calculator'
      }
    }
  }, [_vm._v("Estimator")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v("Contact")])], 1)])])]), _vm._v(" "), (_vm.$route.name === 'home') ? _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "bgvid"
  }, [_c('video', {
    attrs: {
      "playsinline": "",
      "autoplay": "",
      "muted": "",
      "loop": "",
      "poster": "../assets/bgs/palmfield.jpg",
      "id": "bgvid"
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": "/assets/vid1.mp4",
      "type": "video/mp4"
    }
  })])]), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "footnav",
    class: {
      'hero-foot': true, 'foot-has-affix': _vm.affix
    }
  }, [_c('nav', {
    class: {
      'tabs is-boxed is-fullwidth': true, 'foot-affix': _vm.affix
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', [_c('li', {
    class: {
      'is-active': _vm.$route.name === 'trees'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'trees'
      }
    }
  }, [_vm._v("Tree Relocation")])], 1), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.$route.name === 'erosion'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'erosion'
      }
    }
  }, [_vm._v("Erosion Control")])], 1), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.$route.name === 'rows'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'rows'
      }
    }
  }, [_vm._v("ROW Maintenance")])], 1), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.$route.name === 'landscape'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'landscape'
      }
    }
  }, [_vm._v("Landscaping")])], 1), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.$route.name === 'irrigation'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'irrigation'
      }
    }
  }, [_vm._v("Irrigation")])], 1), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.$route.name === 'hydroaxe'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'hydroaxe'
      }
    }
  }, [_vm._v("Hydro-Axing")])], 1)])])])])]), _vm._v(" "), _c('section', {
    staticClass: "main"
  }, [_c('router-view'), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'services'
      }
    }
  }, [_vm._v("Services")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'portfolio'
      }
    }
  }, [_vm._v("Portfolio")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'calculator'
      }
    }
  }, [_vm._v("Estimator")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v("Contact")])], 1)]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-item nav-logos"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/assets/hub.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/assets/ieca.svg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/assets/dbe.svg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/assets/sbe.svg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container has-text-white has-text-centered"
  }, [_c('br'), _vm._v(" "), _c('img', {
    staticClass: "hero-gulf-logo",
    attrs: {
      "src": require("./assets/logos/logo.svg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header-logos"
  }, [_c('img', {
    staticClass: "hero-wide-cert",
    attrs: {
      "src": "/assets/hub-invert.png"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticClass: "hero-narrow-cert",
    attrs: {
      "src": "/assets/dbe-invert.svg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "hero-narrow-cert",
    attrs: {
      "src": "/assets/sbe-invert.svg"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticClass: "hero-wide-cert",
    attrs: {
      "src": "/assets/ieca-invert.svg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-logos"
  }, [_c('img', {
    attrs: {
      "src": "/assets/hub.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/assets/ieca.svg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/assets/dbe.svg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/assets/sbe.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-logo"
  }, [_c('img', {
    staticStyle: {
      "max-width": "150px"
    },
    attrs: {
      "src": require("./assets/logos/footer-logo.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline-content"
  }, [_vm._v("\n          Gulf Coast Contractors, Inc.\n          "), _c('br'), _vm._v("\n          © 1995-2018 All Rights Reserved\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline-content"
  }, [_vm._v("\n          25691 Altas Palmas Road, Harlingen, TX 78552\n          "), _c('br'), _vm._v("\n          (956) 412-6384   1-877-MOV-TREE\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-553794d7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 158
// module chunks = 1